import { AsyncPipe, CommonModule, NgStyle } from '@angular/common';
import { Component, InputSignal, OnInit, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { UserAvatarData } from 'src/app/core/models/user';
import { ScreenService } from 'src/app/core/services/responsive/screen.service';
import { lightenColor } from '../../functions/desaturate';
import { AuthImageUrlPipe } from "../../pipes/auth-image-url.pipe";
import { PlaceholderPictureComponent } from '../placeholder-picture/placeholder-picture.component';

@Component({
  selector: 'app-avatar', standalone: true,
  imports: [PlaceholderPictureComponent, NgStyle, AuthImageUrlPipe, CommonModule, AsyncPipe],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss'
})
export class AvatarComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly screenService = inject(ScreenService);
  avatar: InputSignal<UserAvatarData | null> = input<UserAvatarData | null>(null);
  avatarColor = this.avatar()?.borderColour;
  adjustedColor = '#000000';
  isLearnerAvatar = input<boolean>(false);

  isActive = computed(() => {
    const avatar = this.avatar();
    if (!avatar) return true;
    return avatar.isActive ?? true;
  });

  routeTo() {
    const avatar = this.avatar();
    if (!avatar?.id) return;

    const percent = Number(avatar.enrolmentPercent);

    let route = '/enrolment';

    if (percent != null && percent < 100) {
      this.router.navigate([route]);
      return;
    }

    if (this.isActive()) {
      route = this.screenService.isMobile()
        ? `/learners/${avatar.id}`
        : `/learners/${avatar.id}/profile`;
    } else {
      route = `/learners/${avatar.id}/reports`;
    }

    this.router.navigate([route]);
  }

  ngOnInit() {
    this.avatarColor = this.avatar()?.borderColour;
    this.adjustedColor = lightenColor(this.avatarColor, 50);
  }

  calculateCircumference() {
    const radius = 18; // Matches the radius of the circle in the SVG
    const circumference = 2 * Math.PI * radius;
    const percent = this.avatar()?.enrolmentPercent ?? 0;
    const offset = circumference - (percent / 100) * circumference;
    if (percent === 0) return
    return { offset, circumference }
  }
}
